module.exports = __webpack_public_path__ + "static/img/meio.dea8d11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meio.jpg
// module id = 394
// module chunks = 1